function TableFooter({timeTotal, alreadyPaid}) {
  return (
    <div className="grid grid-cols-[1fr_1fr_3fr_1fr] mb-2 bg-white py-4 items-center px-7 rounded-2xl shadow-md mt-5">
      <div className="flex items-center gap-2">
        <svg
          xmlns="http://www.w3.org/2000/svg"
          width="16"
          height="16"
          viewBox="0 0 16 16"
          className="text-[#5489DA] w-7 h-7"
        >
          <path
            fill="currentColor"
            d="M8 15c-3.86 0-7-3.14-7-7s3.14-7 7-7s7 3.14 7 7s-3.14 7-7 7M8 2C4.69 2 2 4.69 2 8s2.69 6 6 6s6-2.69 6-6s-2.69-6-6-6"
          />
          <path
            fill="currentColor"
            d="M10 10.5c-.09 0-.18-.02-.26-.07l-2.5-1.5A.5.5 0 0 1 7 8.5v-4c0-.28.22-.5.5-.5s.5.22.5.5v3.72l2.26 1.35a.502.502 0 0 1-.26.93"
          />
        </svg>
        <span>Total Time</span>
      </div>
      <div className="flex gap-2"></div>
      <div className="w-fit">
        <div className="flex items-center gap-5">
          <div class="min-w-[115px] px-5 py-2 rounded-2xl bg-[#FFC4CC33]/20 opacity-0">
            <span class="text-xs block text-[#C31919]">Current time</span>
            <time class="font-semibold text-base mt-1 text-[#C31919]">
              00:00:00
            </time>
          </div>
          <div className={"min-w-[115px] px-5 py-2 rounded-2xl bg-[#F7F9FC]"}>
            <span className={"text-xs block text-[#627491]"}>Total Time</span>
            <time className={"font-semibold text-base mt-1 text-[#1A1C1F]"}>
              {timeTotal}
            </time>
          </div>
          <div className={"min-w-[115px] px-5 py-2 rounded-2xl bg-[#F7F9FC]"}>
            <span className={"text-xs block text-[#627491]"}>Already Paid</span>
            <time className={"font-semibold text-base mt-1 text-[#1A1C1F]"}>
              {alreadyPaid}
            </time>
          </div>
        </div>
      </div>
      <div></div>
    </div>
  );
}

export default TableFooter;
